import React, { FC, useEffect, useState } from 'react';
import { ApplicationViewContactInfo } from './ApplicationViewContactInfo';
import { ApplicationViewCompanyInfo } from './ApplicationViewCompanyInfo';
import { ApplicationOwner } from '../application/ApplicationOwner';
import { IOwners } from '../../interfaces/merchant';
import { useFormik } from 'formik';
import { ApplicationViewBusinessDetailsFooter } from './ApplicationViewBusinessDetailsFooter';
import { ApplicationViewHeaderInformation } from './ApplicationViewHeaderInformation';
import {
  getInitialValues,
  IApplicationDetails,
} from '../../constants/new-application/new-application-form';
import { useTranslation } from 'react-i18next';
import { CustomerSupportInformationCart } from '../application/CustomerSupportInformationCart';
import { BusinessModel } from '../application/BusinessModel';
import { ProductInformation } from '../application/ProductInformation';
import { VolumeEstimates } from '../application/VolumeEstimates';
import { fetchApplicationView } from '../../store/merchnts/actions/application-view';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt, STATUSES } from '../../views/login/Login';
import { Spinner } from '../Spinner';
import { getBusinessDetailsValidationSchema } from '../../constants/application-view/application-view-form';
import { fetchMccList, fetchMerchantsLists } from '../../store/merchnts/actions/merchant';
import { ApplicationViewBusinessDetailsDocuments } from '../application/ApplicationViewBusinessDetailsDocuments';
import { useNavigate } from 'react-router-dom';
import { APPLICATION_VIEW_BASE_VIEW, APPLICATION_VIEW_STEPS } from './ApplicationViewAsideMenu';
import AddressCard from '../application/AddressCard';
import BankInformationCard from '../application/BankInformationCard';

export const ApplicationViewBusinessDetails: FC = () => {
  const { t } = useTranslation();
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
  const user = parseJwt(authUser.idToken);
  const mid = user?.['custom:mid'];
  const navigate = useNavigate();

  const { merchantState: { isApplicationViewDataLoading, applicationViewData, merchantsLists }, dispatch } = useMerchants();
  const [ownerData, setOwnerData] = useState<IOwners[]>([]);
  const [checkBoxes, setCheckBoxes] = useState<string[]>([]);
  const [fileList, setFileList] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const formik = useFormik<IApplicationDetails>({
    initialValues: getInitialValues({ partnerId: '', integrationPartnerId: '' }),
    validationSchema: getBusinessDetailsValidationSchema(t),
    onSubmit: () => void 0
  });

  useEffect(() => {
    if (!merchantsLists?.countries?.length) {
      void fetchMerchantsLists(dispatch);
    }
  }, []);

  useEffect(() => {
    void fetchApplicationView({ dispatch, mid, formik });
  }, []);

  useEffect(() => {
    void fetchMccList(dispatch);
  }, []);

  useEffect(() => {
    if (applicationViewData?.statusName === STATUSES.IN_REVIEW || applicationViewData?.statusName === STATUSES.SUBMITTED) {
      navigate(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.SUMMARY}`);
    }

    if (applicationViewData?.owners?.length > 0) {
      setOwnerData(applicationViewData.owners);
    }
    if (applicationViewData?.uploadedDocuments?.length > 0) {
      setUploadedDocuments(applicationViewData.uploadedDocuments);
    }
  }, [applicationViewData]);

  // useEffect(() => {
  //   if (fileList?.length) {
  //     setIsSubmitted(false);
  //   }
  // }, [fileList]);

  if (isApplicationViewDataLoading) {
    return (
      <div className="card h-100">
        <div className="card-body">
          <Spinner pageLoader/>
        </div>
      </div>
    );
  }

  return(
    <>
      <ApplicationViewHeaderInformation />

      <form onSubmit={formik.handleSubmit}>
        <ApplicationViewCompanyInfo formik={formik} formEditStatus={true} />
        <VolumeEstimates formik={formik} formEditStatus={true} isRequired={true}/>

        <ApplicationViewBusinessDetailsDocuments
            fileList={fileList}
            setFileList={setFileList}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            // isError={isSubmitted && !fileList?.length && !uploadedDocuments?.length}
            isError={!!formik?.errors?.['Documents']}
            sectionAdditionalClass="mb-10"
        />

        <BusinessModel
            formik={formik}
            formEditStatus={true}
            isRequired={true}
            urls={applicationViewData?.businessModel?.urls ?? []}
        />

        <ApplicationViewContactInfo formik={formik} formEditStatus={true} isRequired={true} />
        {/*<CustomerSupportInformationCart formik={formik} formEditStatus={true} isRequired={true} />*/}

        <ApplicationOwner
            appOwnerData={ownerData}
            setAppOwnerData={setOwnerData}
            formEditStatus={true}
            showActions={true}
            showAddButton={true}
        />

        {/*<ProductInformation*/}
        {/*  formik={formik}*/}
        {/*  formEditStatus={true}*/}
        {/*  data={applicationViewData?.productInfo?.trafficAcquisition}*/}
        {/*  setCheckBoxes={setCheckBoxes}*/}
        {/*  isRequired={true}*/}
        {/*/>*/}

        <AddressCard formik={formik} formEditStatus={true}/>

        <BankInformationCard
            formEditStatus={true}
            formik={formik}
        />

        <ApplicationViewBusinessDetailsFooter
          formik={formik}
          checkBoxes={checkBoxes}
          fileList={fileList}
          owners={ownerData}
          uploadedDocuments={uploadedDocuments}
          setIsSubmitted={setIsSubmitted}
        />
      </form>

    </>
  );
};
